import { Comment, CreateCommentInput, LexicalText } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface CommentsResponse {
  comments: Comment[]
}

export function fetchComments(context: ApiContext, commentableType: string, commentableId: string) {
  const params = new URLSearchParams({
    commentable_type: commentableType,
    commentable_id: commentableId,
  })

  return apiContextFetch<CommentsResponse>(context, `comments?${params.toString()}`)
}

export async function createComment(
  context: ApiContext,
  data: CreateCommentInput & { commentableType: string; commentableId: string }
) {
  const { commentableType, commentableId, parentId, files = [], ...commentData } = data
  const apiRoot = (process.env.NEXT_PUBLIC_API_URL || "http://localhost:3000/api/").replace("/api/", "")
  const { uploadFileDirectly } = await import("@/utils/direct-upload")
  const signedIds = await Promise.all(files.map((file) => uploadFileDirectly(file, apiRoot, context.token, "comment")))

  return apiContextFetch<Comment>(context, "comments", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      commentable_type: commentableType,
      commentable_id: commentableId,
      comment: {
        ...commentData,
        ...(parentId ? { parent_id: parentId } : {}),
        ...(signedIds.length ? { files: signedIds } : {}),
      },
    }),
  })
}

export function updateComment(context: ApiContext, id: string, content: LexicalText) {
  return apiContextFetch<Comment>(context, `comments/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      comment: { content },
    }),
  })
}

export function deleteComment(context: ApiContext, id: string) {
  return apiContextFetch<void>(context, `comments/${id}`, {
    method: "DELETE",
  })
}

export function toggleReaction(context: ApiContext, commentId: string, emoji: string) {
  return apiContextFetch<void>(context, `comments/${commentId}/reactions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ emoji }),
  })
}
